import * as actionTypes from './actionTypes'
import uuid from 'uuid/v4'
import { getAxios } from '../../lib/projectAxios'
const axios = getAxios()

export const projectProcessGetSurveyData = () => async (dispatch, getState) => {
  let state = getState()

  const recursiveProcessGet = async (attemp) => {
    if (attemp >= 3) {
      return {
        status: 200,
        data: {
          status: false,
        },
      }
    }
    try {
      let result = await axios.post('/webprojects/get/survey', {})
      return result
    } catch (err) {
      console.log('err >>> ', err)
      dispatch({
        type: actionTypes.NOTIFY_ERROR,
        payload: {
          key: uuid(),
          message: `You are offline, trying again in 2 seconds...`,
        },
      })
      await new Promise((resolve) => {
        setTimeout(resolve, 2 * 1000)
      })

      return recursiveProcessGet(attemp + 1)
    }
  }

  let { status, data } = await recursiveProcessGet(0)

  if (data.error) {
    if (data.error == 'limit_submit') {
      dispatch({
        type: actionTypes.FETCH_DATA_ERROR,
        payload: {
          error: state.getIn(
            ['project', 'Settings', 'survey', 'captions', 'Submit Limit Error Message'],
            `This survey was already completed.`
          ),
        },
      })
    } else {
      dispatch({
        type: actionTypes.NOTIFY_ERROR,
        payload: {
          key: uuid(),
          message: data.error,
        },
      })
    }
  }

  dispatch({
    type: actionTypes.PROCESS_SF_SURVEY_MAPPING,
    payload: {
      data: data.data || {},
    },
  })
}
